import config from '@packages/config';
import type { Locale } from '@packages/config';

import { UrlType } from './apiUrl.staticPage';
import { getEndpoint } from './cmsFetcher';

export const getUspEndpoint = (locale: Locale): string =>
  getEndpoint(
    config.staticContent.apiEndpoints.bucket,
    'bucket-usp-bar',
    locale,
    'bucket-usp-bar',
    UrlType.MENU,
  );
